export const AllSortMethods = [
  {
    sortId: "sortItem.best_seller",
    sortText: "Best Sellers",
    sortAttribute: "lw_best_seller",
    sortDirection: "DESC",
    sortQuery: "lw_best_sellers",
  },
  {
    sortId: "sortItem.position",
    sortText: "Featured",
    sortAttribute: "position",
    sortDirection: "ASC",
    sortQuery: "featured",
  },
  {
    sortId: "sortItem.created_at",
    sortText: "New Arrivals",
    sortAttribute: "created_at",
    sortDirection: "DESC",
    sortQuery: "new",
  },
  {
    sortId: "sortItem.high_to_low",
    sortText: "Price: High to Low",
    sortAttribute: "lw_high_to_low",
    sortDirection: "DESC",
    sortQuery: "lw_price_high",
  },
  {
    sortId: "sortItem.low_to_high",
    sortText: "Price: Low to High",
    sortAttribute: "lw_low_to_high",
    sortDirection: "ASC",
    sortQuery: "lw_price_low",
  },
  {
    sortId: "sortItem.most_reviews",
    sortText: "Top Rated",
    sortAttribute: "lw_most_reviews",
    sortDirection: "DESC",
    sortQuery: "lw_top_rated",
  },
]
